import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Skeletonload = () => {
    return (
        <>
            <div className='course_card subject skeleton-card'>
                <Skeleton className="skeleton-box" />
                <Skeleton className="skeleton-text" />
            </div>
            <div className='course_card subject skeleton-card'>
                <Skeleton className="skeleton-box" />
                <Skeleton className="skeleton-text" />
            </div>
            <div className='course_card subject skeleton-card'>
                <Skeleton className="skeleton-box" />
                <Skeleton className="skeleton-text" />
            </div>
            <div className='course_card subject skeleton-card'>
                <Skeleton className="skeleton-box" />
                <Skeleton className="skeleton-text" />
            </div>
            <div className='course_card subject skeleton-card'>
                <Skeleton className="skeleton-box" />
                <Skeleton className="skeleton-text" />
            </div>
            <div className='course_card subject skeleton-card'>
                <Skeleton className="skeleton-box" />
                <Skeleton className="skeleton-text" />
            </div>
        </>
    );
};

export default Skeletonload;
